import {BUILDINGS_CONSTS} from "../constants";

export const initialState = {
    areaData: null,
    initialAreaData: null,

    //-------------
    buildings: [],
    bestOffers: [],
    clear: false,
    filterState: null,
    buildingById: null,
    minPrices: null,
    areas: {
        list: [],
        hasMore: false,
        buildingSlug: null,
        floors: [],
        roomsCount: 0,
        minArea: '',
        maxArea: '',
        minPrice: '',
        maxPrice: '',
        sort: 'price',
    }
};

const buildings = (state = initialState, action) => {

    switch (action.type) {
        case BUILDINGS_CONSTS.GET_AREAS_INFO:
            return {
                ...state,
                areaData: action.payload,
            };
        case BUILDINGS_CONSTS.GET_AREAS_INITIAL_INFO:
            return {
                ...state,
                initialAreaData: action.payload,
                areaData: action.payload
            };
        case BUILDINGS_CONSTS.RESET_AREAS_INFO:
            return {
                ...state,
                areaData: state.initialAreaData,
            };


//---------------------------------------------------------------
        case BUILDINGS_CONSTS.GET_BUILDINGS:
            return {
                ...state,
                buildings: action.payload,
            };
        case BUILDINGS_CONSTS.GET_BUILDING_BY_ID:
            return {
                ...state,
                buildingById: action.payload,
            };

        case BUILDINGS_CONSTS.GET_AREAS:
            return {
                ...state,
                areas: {
                    list: action.payload.reset ? action.payload.data : [...state.areas.list, ...action.payload.data],
                    availableCount: action.payload.availableCount,
                    reservedCount: action.payload.reservedCount,
                    count: action.payload.count,
                    hasMore: action.payload.hasMore,
                    buildingSlug: action.payload.buildingSlug,
                    floors: action.payload.floors,
                    roomsCount: action.payload.roomsCount,
                    minArea: action.payload.minArea,
                    maxArea: action.payload.maxArea,
                    minPrice: action.payload.minPrice,
                    maxPrice: action.payload.maxPrice,
                    sort: action.payload.sort,
                    statuses: action.payload.statuses,
                    type: action.payload.type,
                }
            };
        case BUILDINGS_CONSTS.GET_AREAS_BEST_OFFER:
            return {
                ...state,
                bestOffers: action.payload,
            };

        case BUILDINGS_CONSTS.GET_AREAS_MIN_PRICES:
            return {
                ...state,
                minPrices: action.payload,
            };
        case BUILDINGS_CONSTS.REMOVE_AREAS_LIST:
            return {
                ...state,
                areas: {
                    ...initialState.areas,
                }
            };

        default:
            return state;
    }
};
export default buildings
